












































import { Mixins, Component } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../../../base/components/system/selectors";
import { ObjectUtility } from "../../../../../../../base/utilities";
import { DomainRegistry } from "../../../../../../domain";
import { QuestionnaireVariableFhirPathItem } from "../../../../../../domain/questionnaire";

@Component({
  components: {
    OptionDropDownSelector,
  }
})
export default class QuestionnaireVariableFhirPathItemEditDialog extends Mixins(DialogMixin) {
  confirmed = false;
  isEdit = false;
  items: QuestionnaireVariableFhirPathItem[] = null;
  nameText = "";
  expressionText = "";
  isDeleted = false;

  get titleText(): string {
    return `FHIRパス${this.isEdit ? "編集" : "追加"}(variable)`;
  }

  get isValid(): boolean {
    return this.isDeleted || (!!this.nameText &&
      !!this.expressionText &&
      this.items.every(i => i.name !== this.nameText));
  }

  async show(isEdit: boolean, items: QuestionnaireVariableFhirPathItem[], name: string, expression: string): Promise<boolean> {
    return this.showModal(async () => {
      this.isEdit = isEdit;
      const clone = ObjectUtility.copyDeeply(items) as QuestionnaireVariableFhirPathItem[];
      this.items = isEdit
        ? clone.filter(i => i.name !== name)
        : clone;
      this.nameText = name;
      this.expressionText = expression;
      await this.waitHidden();
      const confirmed = this.confirmed;
      this.clear();
      return confirmed;
    });
  }

  private clear() {
    this.confirmed = false;
    this.isEdit = false;
    this.items = null;
    this.nameText = "";
    this.expressionText = "";
    this.isDeleted = false;
  }

  async confirm() {
    const items = this.items
      .concat(this.isDeleted ? [] : [this.createItem()])
      .sort((a, b) => a.name.localeCompare(b.name));
    await DomainRegistry.instance.questionnaire.getVariableRepository().saveFhirPath(items);
    this.confirmed = true;
    this.isVisible = false;
  }

  private createItem(): QuestionnaireVariableFhirPathItem {
    return {
      name: this.nameText,
      expression: this.expressionText,
    };
  }

  cancel() {
    this.isVisible = false;
  }
}
